import React from 'react';
import {defineMessages} from 'react-intl';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ActionConfirmationModal} from '@igp/shared/components/modal';

const localized = defineMessages({
    title: {
        id: 'DisableAccountConfirmationModal_title',
        defaultMessage: 'Deactivate Agent?',
    },
    listTitle: {
        id: 'DisableAccountConfirmationModal_listTitle',
        defaultMessage: 'Disabling this agent will apply the following effects:',
    },
    listItem1: {
        id: 'DisableAccountConfirmationModal_listItem1',
        defaultMessage: 'The agent will be marked as disabled and no longer eligible for logging in to the agent BO.',
    },
    listItem2: {
        id: 'DisableAccountConfirmationModal_listItem2',
        defaultMessage: 'Their revenue share ratios will be reset to 0.',
    },
    listItem3: {
        id: 'DisableAccountConfirmationModal_listItem3',
        defaultMessage: 'The agent will be excluded from the Negative Carryover Report and CRM Credit Summary Export.',
    },
    listItem4: {
        id: 'DisableAccountConfirmationModal_listItem4',
        defaultMessage: 'This action is reversible, but ratios and routing will not be restored automatically.',
    },
    confirmationQuestion: {
        id: 'DisableAccountConfirmationModal_confirmationQuestion',
        defaultMessage: 'Are you sure you want to proceed?',
    },
});

type DisableAccountConfirmationModalProps = {
    onCancel: () => void;
    onConfirm: () => void;
};

export function DisableAccountConfirmationModal({onCancel, onConfirm}: DisableAccountConfirmationModalProps) {
    return (
        <ActionConfirmationModal
            title={localized.title}
            contentDescription={
                <>
                    <LocalizedText label={localized.listTitle} />
                    <ul>
                        <li>
                            <LocalizedText label={localized.listItem1} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem2} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem3} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem4} />
                        </li>
                    </ul>
                    <LocalizedText label={localized.confirmationQuestion} />
                </>
            }
            handleCancel={onCancel}
            handleConfirm={onConfirm}
        />
    );
}
